(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

    ngModule.controller('PackageWizardModal', ['$scope', '$rootScope', '$uibModalInstance', 'thePackage', 'store', '$uibModal', function($scope, $rootScope, $uibModalInstance, thePackage, store, $uibModal) {

        angular.extend($scope, {

            // vars
            tabs: [],
            packageProducts: [],
            calculatedPackageBaseCost: 0, // the lowest cost of the package, set in the extendPackageProducts method, before a discount is added
            calculatedPackageCost: 0, // the current running total cost of THIS customized package
            customerPackage: {},
            customerPackageProducts: [],
            store: store,
            //methods
            init: function() {
                $scope.thePackage = thePackage;
                $scope.addIntroTab();
                $scope.extendPackageProducts();
                $scope.addReviewTab();
            },

            addToCart: function() {

                angular.extend($scope.thePackage, {
                    customerPackage: $scope.customerPackage,
                    customerPackageProducts: $scope.customerPackageProducts,
                    calculatedPackageCost: $scope.calculatedPackageCost,
                    quantity: 1
                });

                console.log('THE PACKAGE', $scope.thePackage);
                console.log('The EXISTING PACKAGES', $rootScope.cart.packages);

                let packageClone = _.clone($scope.thePackage);

                if($rootScope.cart.packages){
                    $rootScope.cart.packages.push(packageClone);
                } else {
                    $rootScope.cart.packages = [packageClone];
                }

                $rootScope.$emit('cart.package.added', $scope.thePackage);

                $uibModalInstance.close($scope.thePackage);

            },

            switchTab: function($event, $index) {
                _.forEach($scope.tabs, function(tab, index) {
                    tab.activeTab = false;
                    if(index === $index){
                        tab.activeTab = true;
                    }
                });

                $event.stopPropagation();
            },

            extendPackageProducts: function() {

                console.log('extendPackageProducts', thePackage);

                var basePrice = 0;

                _.forEach(thePackage.products, function(product) {
                    let needle = _.find(store.products, {id: product.id});
                    if(needle){


                        needle = trimOutUnselectedAttributes(needle);

                        // console.log('needle', needle);

                        needle.activeImage = needle.featuredImage.productImage;

                        // if(needle.useStoreSpecificProductImage){
                        //
                        //     needle.productImage = needle.featuredImage.productImage;
                        //     needle.activeImage = needle.productImage;
                        //
                        // } else {
                        //
                        //     needle.activeImage = needle.productImage;
                        //
                        // }

                        basePrice += parseFloat(needle.basePrice);

                        needle.activeTab = false;

                        $scope.customerPackageProducts.push({
                            name: needle.name,
                            id: needle.id,
                            quantity: 1,
                            basePrice: needle.basePrice,
                            inPackage: true,
                            package: $scope.thePackage.name,
                            thumbnail: needle.featuredImage.productImage
                        });

                        $scope.tabs.push(needle);
                    }

                });

                $scope.calculatedPackageBaseCost = basePrice;
                $scope.calculatedPackageCost = applyDiscount(basePrice);

                // $scope.addReviewTab();

                // $scope.packageProducts[0].activeTab = true; // setting the first product in the array as active for UI's benefit

            },

            addIntroTab: function() {
                $scope.tabs.push({
                    name: 'Package Instructions',
                    description: $scope.thePackage.description,
                    introTab: true,
                    activeTab: true
                });
            },

            addReviewTab: function() {
                $scope.tabs.push({
                    name: 'Review',
                    description: 'Review tab content.',
                    reviewTab: true
                });
            },

            thumbnailSwitch: function(productImage, product) {

                //$scope.packageProducts[$index].activeImage = productImage;
                product.activeImage = productImage;

            },

            thumbnailLighbox: function(imageToLightbox) {

                $uibModal.open({
                    animation: true,
                    windowTemplateUrl: 'directives/externalStore/fullScreenModalWindowTemplate.html',
                    templateUrl:'directives/externalStore/fullScreenImageModal.html',
                    controller: function($scope, $uibModalInstance, activeImage, $timeout) {

                        $scope.activeImage = activeImage;

                        $scope.maxHeight = window.innerHeight - 50;

                        $scope.close = function () {
                            $uibModalInstance.dismiss('cancel');
                        };

                    },
                    size: 'lg',
                    resolve: {
                        activeImage: function() {
                            return imageToLightbox;
                        }
                    }
                });

            },

            updateProductPrice: function() {

                var packagePrice = $scope.calculatedPackageBaseCost;

                _.forEach($scope.customerPackageProducts, function(product) {

                    _.forEach( product.properties, function(value, key){

                        if(key === 'customName' || key === 'customNumber'){
                            if(_.isEmpty(value.name)){
                                packagePrice = packagePrice;
                            } else {
                                if(key === 'customName'){
                                    if(product.customizationNameCost){
                                        packagePrice = packagePrice + product.customizationNameCost;
                                    } else {
                                        var needle = _.find(store.products, {id: product.id});
                                        if(needle.customizationNameCost){
                                            packagePrice += needle.customizationNameCost;
                                        } else {
                                            packagePrice = packagePrice;
                                        }
                                    }
                                } else {
                                    if(product.customizationNumberCost){
                                        packagePrice = packagePrice + product.customizationNumberCost;
                                    } else {
                                        var needle = _.find(store.products, {id: product.id});
                                        if(needle.customizationNumberCost){
                                            packagePrice += needle.customizationNumberCost;
                                        } else {
                                            packagePrice = packagePrice;
                                        }
                                    }
                                }
                            }
                        } else {
                            if(value.price){
                                if(Math.sign(value.price) === -1){
                                    packagePrice = packagePrice;
                                } else {
                                    packagePrice = packagePrice + value.price;
                                }
                            } else {
                                packagePrice = packagePrice; // product.price = 0
                            }
                        }
                    });

                });

                $scope.calculatedPackageCost = applyDiscount(packagePrice);

            },

            prettyAttributeInOption: function(attribute) {

                let costString = '';

                if(attribute.price === 0){
                    // whatever the attribute is, its not changing the price
                    // nothing happening here, move on

                } else {

                    if(Math.sign(attribute.price) === 1 ){

                        // we have a positive price increase
                        costString = ' [$ ' + attribute.price + ']';

                    }
                }

                return attribute.name + costString;

            },

            cancel: function () {
                $uibModalInstance.dismiss('cancel');
            },

            test: function() {
                console.log('testing');
            }

        });

        $scope.init();

        // $scope.watch('')

        function applyDiscount(passedAmountToDiscount) {

            // console.log('passedAmountToDiscount',passedAmountToDiscount);

            var amountToDiscount = passedAmountToDiscount || $scope.calculatedPackageCost;

            if($scope.thePackage.type === '$'){

                return amountToDiscount - $scope.thePackage.amount;

            } else {

                var discountPercentageAmount = amountToDiscount * ($scope.thePackage.amount/100);

                return amountToDiscount - discountPercentageAmount;

            }
        };

        function trimOutUnselectedAttributes(product) {

            let trimmedProductProperties = [];

            _.forEach(product.properties, (property) => {

                if(_.find(property.attributes, {'selected': true})){

                    trimmedProductProperties.push(property)

                }

            });

            product.properties = trimmedProductProperties;

            return product;

        };

    }]);

})();
